<div class="configurationBannerHeader" (click)="toggleExpansion()">
  <label class="configurationBannerLabel">Controls</label>
  <span class="spacer"></span>
  <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
</div>
@if (!collapsed) {
  <div class="selectionsWrapper">
    <div class="configurationDetailRow">
      <span class="fullWidthConfigurationInput">
        @if (controlVoltageSelection) {
          <span>
            <label class="halfWidthInputLabel">Control Voltage:</label>
            <select class="halfWidthInputField" #controlVoltageInput
              [class.invalidConfigurationSelection]="isInvalidSelection(controlVoltageSelection.Name)"
              (change)="selectedValueChanged(controlVoltageSelection.Name, controlVoltageInput.value)"
              [value]="controlVoltageSelection.Value.toString()">
              @for (allowable of controlVoltageSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="controlVoltageSelection.Value && controlVoltageSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
      <span class="fullWidthConfigurationInput">
        @if (serviceSwitchSelection) {
          <span>
            <label class="halfWidthInputLabel">Service Switch:</label>
            <select class="halfWidthInputField" #serviceSwitchInput
              [class.invalidConfigurationSelection]="isInvalidSelection(serviceSwitchSelection.Name)"
              (change)="selectedValueChanged(serviceSwitchSelection.Name, serviceSwitchInput.value)"
              [value]="serviceSwitchSelection.Value.toString()">
              @for (allowable of serviceSwitchSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="serviceSwitchSelection.Value && serviceSwitchSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
    </div>
    <div class="configurationDetailRow">
      <span class="fullWidthConfigurationInput">
        @if (thermostatTypeSelection) {
          <span>
            <label class="halfWidthInputLabel">Thermostat Type:</label>
            <select class="halfWidthInputField" #thermostatInput
              [class.invalidConfigurationSelection]="isInvalidSelection(thermostatTypeSelection.Name)"
              (change)="selectedValueChanged(thermostatTypeSelection.Name, thermostatInput.value)"
              [value]="thermostatTypeSelection.Value.toString()">
              @for (allowable of thermostatTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="thermostatTypeSelection.Value && thermostatTypeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
      <span class="fullWidthConfigurationInput">
        @if (skyportServiceSelection) {
          <span>
            <label [class.invalidConfigurationSelection]="isInvalidSelection(skyportServiceSelection.Name)"
              for="skyportServiceInput"
            class="halfWidthInputLabel">IEC Skyport Setup Service<br/>(Wi-Fi Thermostat):</label>
            <input type="checkbox" class="checkboxInput" id="skyportServiceInput"
              #skyportServiceInput [checked]="'true' === skyportServiceSelection.Value"
              (change)="selectedValueChanged(skyportServiceSelection.Name, skyportServiceInput.checked.toString())">
          </span>
        }
      </span>
    </div>
    <div class="configurationDetailRow">
      <span class="fullWidthConfigurationInput">
        @if (thermostatLocationSelection) {
          <span>
            <label class="halfWidthInputLabel">Thermostat Location:</label>
            <select class="halfWidthInputField" #thermostatLocationInput
              [class.invalidConfigurationSelection]="isInvalidSelection(thermostatLocationSelection.Name)"
              (change)="selectedValueChanged(thermostatLocationSelection.Name, thermostatLocationInput.value)"
              [value]="thermostatLocationSelection.Value.toString()">
              @for (allowable of thermostatLocationSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="thermostatLocationSelection.Value && thermostatLocationSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
      <span class="fullWidthConfigurationInput">
        @if (condensateSwitchSelection) {
          <span>
            <label [class.invalidConfigurationSelection]="isInvalidSelection(condensateSwitchSelection.Name)"
            for="condensateSwitchInput" class="halfWidthInputLabel">Condensate Switch:</label>
            <input type="checkbox" class="checkboxInput" id="condensateSwitchInput"
              #condensateSwitchInput [checked]="'true' === condensateSwitchSelection.Value"
              (change)="selectedValueChanged(condensateSwitchSelection.Name, condensateSwitchInput.checked.toString())">
          </span>
        }
      </span>
    </div>
    <div class="configurationDetailRow">
      <span class="fullWidthConfigurationInput">
        @if (controlDoorSelection) {
          <span>
            <label class="halfWidthInputLabel">Control Door:</label>
            <select class="halfWidthInputField" #controlDoorsInput
              [class.invalidConfigurationSelection]="isInvalidSelection(controlDoorSelection.Name)"
              (change)="selectedValueChanged(controlDoorSelection.Name, controlDoorsInput.value)"
              [value]="controlDoorSelection.Value.toString()">
              @for (allowable of controlDoorSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="controlDoorSelection.Value && controlDoorSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
      <span class="fullWidthConfigurationInput">
        @if (terminalStripSelection) {
          <span>
            <label [class.invalidConfigurationSelection]="isInvalidSelection(terminalStripSelection.Name)"
            for="terminalStripInput" class="halfWidthInputLabel">Terminal Strip:</label>
            <input type="checkbox" class="checkboxInput" id="terminalStripInput"
              #terminalStripInput [checked]="'true' === terminalStripSelection.Value"
              (change)="selectedValueChanged(terminalStripSelection.Name, terminalStripInput.checked.toString())">
          </span>
        }
      </span>
    </div>
    <div class="configurationDetailRow">
      <span class="fullWidthConfigurationInput">
        @if (doorCamlocksSelection) {
          <span>
            <label class="halfWidthInputLabel">Door Camlocks:</label>
            <select class="halfWidthInputField" #doorCamlocksInput
              [class.invalidConfigurationSelection]="isInvalidSelection(doorCamlocksSelection.Name)"
              (change)="selectedValueChanged(doorCamlocksSelection.Name, doorCamlocksInput.value)"
              [value]="doorCamlocksSelection.Value.toString()">
              @for (allowable of doorCamlocksSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="doorCamlocksSelection.Value && doorCamlocksSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
    </div>
  </div>
}
